import React, { useContext } from 'react';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Services.scss';
import Service from '../../components/Service/Service';
import { Link } from 'react-router-dom';
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import rootImage from '../../assets/newmonaassets/image_mona_root.jpg';
import implantImage from '../../assets/newmonaassets/mona-implant.png';
import whiteningImage from '../../assets/newmonaassets/image_whitening.jpg';
import laminaImage from '../../assets/newmonaassets/image_lamina_550x500.jpg';
import { LanguageContext } from '../../context/LanguageContext';

const content = {
    tr: {
        sectionTitle: "TEDAVİLERİMİZ",
        mainTitle: "Ağız ve Diş Sağlığında Güvenilir Çözüm",
        description: "Mona Klinik olarak Kadıköy'deki modern kliniğimizde, siz değerli hastalarımızın güvenini kazanmak, kaygılarınızı ortadan kaldırmak için en güncel tedavi teknolojilerini kullanıyoruz. 20 yıllık tecrübemiz ve uzman kadromuzla, sorunlarınıza kalıcı ve ekonomik çözümler sunuyoruz.",
        services: [
            {
                title: "Protez",
                description: "Eksik dişlerinizi, doğal görünümlü ve konforlu protezlerle tamamlıyoruz.",
                image: laminaImage,
                directSlug: "implant-ustu-protezler-estetik-bir-gulumseme-icin-etkili-cozum"
            },
            {
                title: "İmplant",
                description: "Kalıcı ve sağlıklı çözümler için ileri implant teknolojileri kullanıyoruz.",
                image: implantImage,
                directSlug: "implant-tedavisi-eksik-disleriniz-icin-mukemmel-cozum"
            },
            {
                title: "Beyazlatma",
                description: "Profesyonel diş beyazlatma ile daha parlak ve güzel bir gülüşe kavuşun.",
                image: whiteningImage,
                directSlug: "dis-beyazlatma-estetik-gulusun-sirri"
            },
            {
                title: "Kanal Tedavisi",
                description: "Ağrısız ve konforlu kanal tedavisi ile dişlerinizi kurtarıyoruz.",
                image: rootImage,
                directSlug: "endodonti-dis-kanal-tedavisi"
            }
        ]
    },
    en: {
        sectionTitle: "OUR TREATMENTS",
        mainTitle: "Trusted Solution in Dental Health",
        description: "At Mona Clinic, located in Kadıköy, we use the latest treatment technologies to gain the trust of our valued patients and eliminate your concerns. With our 20 years of experience and expert staff, we offer permanent and economical solutions to your problems.",
        services: [
            {
                title: "Dentures",
                description: "We complete your missing teeth with natural-looking and comfortable dentures.",
                image: laminaImage,
                directSlug: "implant-ustu-protezler-estetik-bir-gulumseme-icin-etkili-cozum"
            },
            {
                title: "Implants",
                description: "We use advanced implant technologies for permanent and healthy solutions.",
                image: implantImage,
                directSlug: "implant-tedavisi-eksik-disleriniz-icin-mukemmel-cozum"
            },
            {
                title: "Whitening",
                description: "Get a brighter and more beautiful smile with professional teeth whitening.",
                image: whiteningImage,
                directSlug: "dis-beyazlatma-estetik-gulusun-sirri"
            },
            {
                title: "Root Canal",
                description: "We save your teeth with painless and comfortable root canal treatment.",
                image: rootImage,
                directSlug: "endodonti-dis-kanal-tedavisi"
            }
        ]
    }
};

const Services = () => {
    const { t } = useContext(LanguageContext);
    
    return (
        <section className='service-section pt-100 pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-sm-6">
                        <SectionTitle 
                            subTitle={t('services.sectionTitle')} 
                            title={t('services.mainTitle')}
                        />
                    </div>
                    <div className="col-lg-6 col-sm-6">
                        <p className='service-title-text'>{t('services.description')}</p>
                    </div>
                </div>

                <div className="row">
                    {
                        content.tr.services.map((singleService, index) => 
                            <Service key={index} serviceList={singleService}/>
                        )
                    }
                </div>
            </div>

            <div className="services-link text-center">
                <Link to='/tedaviler'>
                    Tüm Tedavilerimizi İnceleyin
                    <BsFillArrowRightCircleFill/>
                </Link>
            </div>
        </section>
    );
};

export default Services;